module.exports = __webpack_public_path__ + "media/src/images/icons/folder-1332bc3ae709cde8c19b57b5199beb13.svg";